import type { LivePlane } from "./types";

/** dump1090 / readsb aircraft.json schema (minimal shape we need). */
export interface Dump1090Aircraft {
  hex: string;
  flight?: string;
  lat?: number;
  lon?: number;
  alt_baro?: number | "ground";
  gs?: number;
  track?: number;
  squawk?: string;
  category?: string;
}

/** Pi adsb-streamer's compact custom schema (different field names from dump1090). */
export interface PiCompactAircraft {
  hex: string;
  call?: string;
  lat?: number;
  lon?: number;
  alt?: number | "ground";
  spd?: number;
  hdg?: number;
  sqk?: string;
}

export interface AnyAircraftJson {
  aircraft?: Dump1090Aircraft[];
  ac?: PiCompactAircraft[];
  now?: number;
  ts?: number;
}

/**
 * Pi's adsb-streamer returns a compact schema (`ac[]` with `call/hdg/sqk/alt/spd`),
 * dump1090-fa / readsb return the full schema (`aircraft[]` with `flight/track/squawk/alt_baro/gs`).
 * Accept either so the SPA works against any /data/aircraft.json producer.
 *
 * Pure — no DOM / store / network access; safe to unit-test in isolation.
 */
export function parseAircraftJson(json: AnyAircraftJson): LivePlane[] {
  const list = json.aircraft ?? json.ac ?? [];
  return list
    .filter((a) => typeof a.lat === "number" && typeof a.lon === "number")
    .map((a) => {
      const compact = a as PiCompactAircraft;
      const full = a as Dump1090Aircraft;
      const altRaw = full.alt_baro ?? compact.alt;
      return {
        id: a.hex,
        call: (full.flight ?? compact.call ?? a.hex).trim(),
        lat: a.lat!,
        lon: a.lon!,
        hdg: full.track ?? compact.hdg ?? 0,
        alt: typeof altRaw === "number" ? altRaw : 0,
        spd: full.gs ?? compact.spd ?? 0,
        squawk: full.squawk ?? compact.sqk,
      };
    });
}
